import { ThemeComponent } from "@/theme/ThemeComponent";
import { ProductDetails } from "../Product/ProductDetails";
import { ProductPage } from "@apptus/esales-api";

export class VoyadoProductSwatches extends ThemeComponent {
    init() {
        this.listenForProductLoaded();
    }

    listenForProductLoaded() {
        const productDetails = document.querySelector('product-details') as ProductDetails;

        this.$subscribe(productDetails.onVoyadoProductLoaded, (result) => {
            this.renderSwatches(result);
        });
    }

    renderSwatches(result: ProductPage) {
        const swatches = result.productGroup?.products.map((product) => {
            const swatchImage = product.imageInfo.images.find((image) => image.alt === '[swatch-hide]');

            return {
                isCurrentProduct: window.location.pathname === product.link,
                link: product.link,
                image: swatchImage,
            };
        }).filter((swatch) => swatch.image !== undefined);

        const swatchesHTML = swatches?.map((swatch) => `
            <a 
              class="product-swatches__item ${swatch.isCurrentProduct ? 'product-swatches__item--active' : ''}" 
              href="${swatch.link}"
            >
                <img 
                    src="${swatch.image?.sources[0].url}" 
                    alt="{{ current_colour | escape }}"
                    width="24"
                    height="24"
                >
            </a>
          `).join('');

        this.innerHTML = swatchesHTML || '';
    }
}
